<template>
    <div class="px-4 sm:px-6 lg:px-8">

        <div class="-mx-4 mt-6 overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:-mx-6 md:mx-0 md:rounded-lg">

            <div v-if="messages.length > 0" class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">

                <MessagesTableTrashWarning v-if="type === 'trash'"/>

                <MessagesTableActionHeader @refreshMessages="refreshMessages"/>

                <table class="min-w-full divide-y divide-gray-300">

                    <MessagesTableHeader :type="type"/>

                    <tbody class="divide-y divide-gray-200 bg-white">

                        <MessagesTableRow class="even:bg-gray-50" :type="type" :message="message" @refreshMessages="refreshMessages" v-for="message in messages"/>

                    </tbody>
                </table>
            </div>
        </div>
    </div>

</template>

<script>
import MessagesTableRow from "./MessagesTableRow";
import MessagesTableHeader from "./MessagesTableHeader";
import MessagesTableActionHeader from "./MessagesTableActionHeader";
import MessagesTableTrashWarning from "./MessagesTableTrashWarning";
export default {
    name: "MessagesTable",
    components: {MessagesTableTrashWarning, MessagesTableActionHeader, MessagesTableHeader, MessagesTableRow},
    props: ['type', 'messages'],
    emits: ['refreshMessages'],
    data(){
        return {

        }
    },
    methods: {
        refreshMessages(manual = 0){
            this.$emit('refreshMessages', manual);
        }
    },


}
</script>

<style scoped>

</style>
